import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.vectorgrid';
import 'leaflet-geometryutil';
import { useMap } from 'react-leaflet';

const FirePerimetersLayer = () => {
  const { map } = useMap();
  const layerRef = useRef(null);

  useEffect(() => {
    if (!map) return;

    // Cleanup old layer if exists
    if (layerRef.current) {
      map.removeLayer(layerRef.current);
      layerRef.current = null;
    }

    try {
      const layer = L.vectorGrid.protobuf(
        'https://maptiles.watchduty.org/fireperimeters_active/{z}/{x}/{y}',
        {
          vectorTileLayerStyles: {
            fireperimeters_active: {
              fill: true,
              weight: 1,
              fillColor: 'orange',
              color: 'red',
              fillOpacity: 0.4,
              opacity: 1,
            },
          },
          interactive: true,
        }
      );

      layer.addTo(map);
      layerRef.current = layer;
    } catch (error) {
      console.error('Failed to load fire perimeters layer:', error);
      // Optionally show fallback or notify user here
    }

    return () => {
      if (map && layerRef.current) {
        map.removeLayer(layerRef.current);
        layerRef.current = null;
      }
    };
  }, [map]);

  return null;
};

export default FirePerimetersLayer;
